import { FilterGroup } from '../filter/filter-group';

export class FeatureRequest {

  filterGroup: FilterGroup;

}
